// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"f411f527","856":"70b1ac9b","935":"9b6b3c92"}[chunkId] + ".js";
};